import React from "react";

export default function ClassicCell({ cell, table, getValue }) {
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;
	const isHidden = hiddenColumns && hiddenColumns.find((item) => item.id === columnId);

	if (isHidden) return <div className="ignore"></div>;
	return <div>{getValue()}</div>;
}
